import React, { lazy, Suspense, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import useFetch, { requests } from 'common-hooks/use-fetch'
import LoadingIndicator from 'common-components/loading-indicator'


const AppLoader = () => {
  const { i18n } = useTranslation()
  const lazyVar = useRef<any>(null)
  const [{ lang, theme, title /*, template */ }, loading] = useFetch(requests.GET_SETTINGS)


  useEffect(() => {
    i18n.changeLanguage(lang)
  }, [lang]) // eslint-disable-line react-hooks/exhaustive-deps


  useEffect(() => {
    lazyVar.current = lazy(() => import('../applications').then(module => {
      if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
        console.log('application loaded: ', module)
      }
      return ({ default: module.CafeteriaMenu })
    }))
  }, [])

  const LazyComponent = lazyVar.current

  return (
    (loading || !LazyComponent)
      ? <div>
        {process.env.REACT_APP_SHOW_TEST_LINK === 'true'
          && <a href="?auth=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY2hvb2xfaWQiOjU4N30.JmnVbEQcEJtJo5JQAVwKwYnP1xfsBbA797U9SCbJIIY">
            {'Ссылка для теста'}
          </a>}
        <LoadingIndicator />
      </div>
      : <Suspense fallback={<LoadingIndicator />}>
        <LazyComponent theme={theme} title={title} />
      </Suspense>
  )
}

export default AppLoader
